const resource = {
    resource_identifier_in_use: 'API 식별자 {{indicator}}가 이미 사용 중입니다',
    cannot_delete_management_api: 'Logto 管理 API를 삭제할 수 없습니다.',
    cannot_modify_management_api: 'Logto 관리 API를 수정할 수 없습니다.',
};
export default Object.freeze(resource);
